import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { adminApi } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = async () => {
    await adminApi.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const RequireAdmin = () => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen bg-ink" data-testid="admin-checking" />;
  if (!user) return <Navigate to="/admin/connexion" replace state={{ from: loc.pathname }} />;
  return <Outlet />;
};
